import * as React from 'react';

import NewsArchiveCtx from '@/context/newsArchiveCtx';
import type { ArticleType } from '@/types/ArticleType';
import type { Category } from '@/utils/functions/wordpress/fetchCategories';
import fetchPosts from '@/utils/functions/wordpress/fetchPosts';

import NewsFeed from '../components/NewsFeed/NewsFeed';
import SectionHeader from '../components/SectionHeader';

type NewsArchiveProps = {
    articles: ArticleType[] | null;
    categories: Category[];
    authors: Category[];
    tags: Category[];
};

const NewsArchivePage = (props: NewsArchiveProps) => {
    const [filteredPosts, setFilteredPosts] = React.useState<any>([]);

    const newsArchiveCtx = React.useContext(NewsArchiveCtx);

    const { articles, categories, authors, tags } = props;

    React.useEffect(() => {
        const urlQuery = categories.filter((item: any) => item.slug === newsArchiveCtx.query);
        if (urlQuery) {
            newsArchiveCtx.setCategories([...newsArchiveCtx.categories, ...urlQuery]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newsArchiveCtx.query]);

    // Fetch post by filters
    const getFilteredPosts = async () => {
        newsArchiveCtx.setShowLoader(true);

        const result = await fetchPosts({
            limit: 12,
            page: newsArchiveCtx.page,
            filter: {
                categories: newsArchiveCtx.categoriesIDs ? newsArchiveCtx.categoriesIDs : null,
                tags: newsArchiveCtx.tagsIDs ? newsArchiveCtx.tagsIDs : null,
                author: newsArchiveCtx.author ? newsArchiveCtx.author.id : null,
            },
        });
        // console.log(result);

        // Get filtered posts first page
        if (result.length) {
            newsArchiveCtx.setHasData(true);
            newsArchiveCtx.setShowLoader(false);
            if (newsArchiveCtx.page === 1) {
                setFilteredPosts(result);
                if (result.length < 12) {
                    newsArchiveCtx.setHasData(false);
                } else {
                    newsArchiveCtx.setHasData(true);
                }
                // console.log(filteredPosts);
            } else {
                // Pagination
                setFilteredPosts([...filteredPosts, ...result]);
                if (result.length < 12) {
                    newsArchiveCtx.setHasData(false);
                } else {
                    newsArchiveCtx.setHasData(true);
                }
                // console.log(filteredPosts);
            }
        }
    };

    // Reset page counter after new filter value is selected and fetch new posts
    React.useEffect(() => {
        if (newsArchiveCtx.page === 1) {
            getFilteredPosts();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newsArchiveCtx.categories, newsArchiveCtx.tags, newsArchiveCtx.author]);

    // Fetch more posts when page count increases
    React.useEffect(() => {
        getFilteredPosts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newsArchiveCtx.page]);

    return (
        <main className="w-full">
            <section>
                <SectionHeader categories={categories} tags={tags} authors={authors} />
            </section>
            <section>
                <NewsFeed articles={filteredPosts || articles} />
            </section>
        </main>
    );
};

export default NewsArchivePage;
